import styled from "styled-components";

const NewsWrapper = styled.div`
  display: flex;

  a {
    color: ${(p) => p.theme.colors.brand01};
  }
`;

const Bullet = styled.div`
  background-color: ${(p) => p.theme.colors.ui01};
  width: 9px;
  height: 9px;
  border-radius: 50%;
  display: inline-block;
  margin-right: ${(p) => p.theme.spacing.xxs};
`;

export { NewsWrapper, Bullet };
